import { ButtonDesignTokens } from "@primeuix/themes/types/button";
import { primitiveColorTokens, primitiveLayoutTokens } from "src/assets/layout/styles/tokens/primitive";

export const button: ButtonDesignTokens = {
    root: {
        borderRadius: primitiveLayoutTokens.borderRadius,
        paddingX: "1rem",
        paddingY: "0.5rem",
    },
    colorScheme: {
        light: {
            // NOTE - BS - general button styles
            root: {
                primary: {
                    hoverBackground: `color-mix(in srgb, ${primitiveColorTokens.blue[450]}, black 10%)`,
                    activeBackground: `color-mix(in srgb, ${primitiveColorTokens.blue[450]}, black 10%)`,
                    hoverBorderColor: primitiveColorTokens.blue[600],
                    activeBorderColor: primitiveColorTokens.blue[600],
                },
                secondary: {
                    color: primitiveColorTokens.grey[700],
                    background: primitiveColorTokens.grey[450],
                    hoverBackground: primitiveColorTokens.grey[525],
                    activeBackground: primitiveColorTokens.grey[525],
                    hoverColor: primitiveColorTokens.blue[850],
                    hoverBorderColor: primitiveColorTokens.shade[200],
                },
            },
            text: {
                primary: {
                    color: primitiveColorTokens.blue[650],
                },
            },
        },
    },
    css: () => {
        /**
         * Base Overrides for p-button
         */
        const base = `
            .p-button:focus-visible {
                outline: 2px solid var(--p-azara-blue-450);
                outline-offset: 2px;
            }

            .p-button.p-button-icon-only .p-button-icon {
                margin: 0;
            }

            .p-buttongroup .p-button:not(:last-child) {
                border-right-color: rgba(255, 255, 255, 0.3);
            }
        `;

        return base;
    },
};
